/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerievideoVideoidLangsQueryResponse,
  GetApiV1SerievideoVideoidLangsPathParams,
  GetApiV1SerievideoVideoidLangsQueryParams,
  GetApiV1SerievideoVideoidLangs401,
  GetApiV1SerievideoVideoidLangs404,
  GetApiV1SerievideoVideoidLangs500,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangs.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerievideoVideoidLangs } from "../../clients/serieVideoIdiomasController/getApiV1SerievideoVideoidLangs.ts";

export const getApiV1SerievideoVideoidLangsQueryKey = (
  videoId: GetApiV1SerievideoVideoidLangsPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsQueryParams,
) =>
  [
    { url: "/api/v1/serievideo/:videoId/langs", params: { videoId: videoId } },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1SerievideoVideoidLangsQueryKey = ReturnType<
  typeof getApiV1SerievideoVideoidLangsQueryKey
>;

export function getApiV1SerievideoVideoidLangsQueryOptions(
  videoId: GetApiV1SerievideoVideoidLangsPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerievideoVideoidLangsQueryKey(videoId, params);
  return queryOptions<
    GetApiV1SerievideoVideoidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangs401
      | GetApiV1SerievideoVideoidLangs404
      | GetApiV1SerievideoVideoidLangs500
    >,
    GetApiV1SerievideoVideoidLangsQueryResponse,
    typeof queryKey
  >({
    enabled: !!videoId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerievideoVideoidLangs(videoId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de traduções (idiomas) de um vídeo. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs}
 */
export function useGetApiV1SerievideoVideoidLangs<
  TData = GetApiV1SerievideoVideoidLangsQueryResponse,
  TQueryData = GetApiV1SerievideoVideoidLangsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerievideoVideoidLangsQueryKey,
>(
  videoId: GetApiV1SerievideoVideoidLangsPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerievideoVideoidLangsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerievideoVideoidLangs401
          | GetApiV1SerievideoVideoidLangs404
          | GetApiV1SerievideoVideoidLangs500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1SerievideoVideoidLangsQueryKey(videoId, params);

  const query = useQuery(
    {
      ...getApiV1SerievideoVideoidLangsQueryOptions(videoId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangs401
      | GetApiV1SerievideoVideoidLangs404
      | GetApiV1SerievideoVideoidLangs500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
